module.exports = __webpack_public_path__ + "img/horizontal_6_1_6005.43afa92e.png";